import { Box } from '@mui/material';
import { Grid } from '@/common/grid/Grid';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Split } from '@/common/split/Split';
import { ValList } from '@/common/val/ValList'
import { useCallback, useEffect, useRef, useState } from 'react';

export const SubValList = ({ parentEntityId }) => {

  const [selectedVal, setSelectedVal] = useState();
  const [fieldDefs, setFieldDefs] = useState();

  const gridRef = useRef();
  const rsrc = useRsrc();

  const module = useModuleFromRoute();

  const handleSelect = useCallback((val) => {
    setSelectedVal(val);
  }, []);

  const onGridReady = (params) => {
    const dataSource = {
      getRows: (params) => {

         const reqParam = {
          id: parentEntityId,
          valCode: selectedVal.code,
          valMsg: selectedVal.msg,
          startRow: params.startRow,
          endRow: params.endRow
        };

        const plugin = 'SUB_VAL_VIEWER_PLUGIN';
        const entity = 'SUB';

        rsrc.viewerRows(module, plugin, reqParam, entity).then(res => {
          gridRef.current.onGridSuccess(res, params);
          gridRef.current.resize();
        })

        rsrc.viewerCount(module, plugin, reqParam, entity).then(count => {
          gridRef.current.setCount(count);
        })

        rsrc.viewerAggTotals(module, plugin, reqParam, entity).then(aggTotals => {
          gridRef.current.setTotalsRow(aggTotals);
        })
      }
    }

    gridRef.current.setDataSource(dataSource);
  }

  /* Refresh grid on change of filter expression */
  useEffect(() => {
    if (!gridRef.current || !selectedVal) return;
    onGridReady();
  }, [selectedVal]);

  useEffect(() => {
    if (!selectedVal) return;
    const reqParam = {
      id: parentEntityId,
      valCode: selectedVal.code,
      valMsg: selectedVal.msg
    };

    rsrc.viewerFieldDefs(module, 'SUB_VAL_VIEWER_PLUGIN', reqParam, 'SUB').then(fieldDefs => {
      setFieldDefs(fieldDefs);
    });
  }, [selectedVal]);

  return (

    <Split direction="vertical" showSecondChild={!!fieldDefs?.length && !!selectedVal} initialSplit={40}>
      <ValList
        parentEntity="SUB"
        parentEntityId={parentEntityId}
        onSelect={handleSelect}
      />

      {fieldDefs && (<Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Grid
          ref={gridRef}
          gridOptions={{ fieldDefs }}
          events={{ onGridReady }}
        />
      </Box>)}
    </Split>
  )
}